import React from 'react';
import Communities from './Communities';

/**
 * Variante densa con avatares — igual a /communities2 (tile cuadrado, 2 por
 * fila en mobile) pero en lugar del contador "👤 N" muestra los círculos
 * de fotos de perfil de hasta 3 miembros + un "+N" para el resto, igual que
 * la card normal de /communities en su esquina superior derecha.
 */
function Communities3() {
  return <Communities dense avatarMode />;
}

export default Communities3;
